import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { IconInformationSmall } from "@amzn/stencil-react-icons";
import { IItemVersion } from "@/common/types/item.types";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { formatPrice } from "@/common/helpers/price.utils";
import { SelectChildSku } from "@/pages/hardware-details/components/SelectChildSku/select-child-sku";
import React from "react";
import { useHistory } from "react-router-dom";
import { Paths } from "@/common/paths/paths";

export interface OrderPanelProps {
  priceAmount: number;
  priceCurrency: string;
  versions: IItemVersion[];
  defaultVersion: IItemVersion | undefined;
  updateVersionSelected: (version: IItemVersion) => void;
  parentName?: string;
  parentTxId?: string;
}

export const OrderPanel: React.FC<OrderPanelProps> = ({
  priceAmount,
  priceCurrency,
  versions,
  defaultVersion,
  updateVersionSelected,
  parentName,
  parentTxId,
}) => {
  const history = useHistory();

  const handleOrderNow = () => {
    history.push({
      pathname: Paths.checkout.url,
      state: { versions, defaultVersion, parentName, parentTxId },
    });
  };

  return (
    <Col className="pdp-column-right" alignItems="flex-start">
      <View className="order-now">
        <Row>
          <Col alignItems="start">
            <Text fontSize="T400" fontWeight="regular" data-testid="product-price">
              {`${getString("pricing.approximate")} ${formatPrice(priceAmount, priceCurrency, {
                free: getString("pricing.free"),
                noPrice: getString("pricing.noPrice"),
              })}`}
            </Text>

            <Row
              gridGap="S100"
              margin={{ top: "S300" }}
              alignItems="start"
            >
              <View>
                <IconInformationSmall />
              </View>
              <Text lineHeight={1.3} data-testid="cost-disclaimer">
                {`${getString("ordering.vendorCostEstimateDisclaimer")} ${getString(
                  "ordering.costDisclaimerText"
                )}`}
              </Text>
            </Row>

            {versions.length > 0 && (
              <View margin={{ top: "S250" }} width="70%">
                <SelectChildSku
                  versions={versions}
                  selectedVersion={defaultVersion}
                  onChange={updateVersionSelected}
                />
              </View>
            )}

            <View margin={{ top: "S300" }}>
              <Button
                variant={ButtonVariant.Primary}
                data-testid="order-button"
                data-cy="order-now-button"
                disabled={!defaultVersion}
                onClick={handleOrderNow}
              >
                {getString("ordering.orderNow")}
              </Button>
            </View>
          </Col>
        </Row>
      </View>
    </Col>
  );
};
